import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Console } from '@angular/core/src/console';
import { Observable } from 'rxjs/Observable';
import 'rxjs/Rx';
import { GlobalProvider } from '../global/global';
/*
  Generated class for the IndicadoresProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class IndicadoresProvider {
  private api: string = "";
  constructor(public http: Http, public global:GlobalProvider) {
    this.api = this.global.api;
    
  }

  public all(clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "clavecongreso":clavecongreso
    };
    console.log(parametros);
    console.log(this.api+"indicadores/lista.php");
     return this.http.post(this.api+"indicadores/lista.php", parametros, options).map(
      (response) => {
         
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }
  public consulta(sql,clavecongreso): Observable<any> {
 
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers });
    let parametros ={
      "token":this.global.token,
      "clavecongreso":clavecongreso,
      "sql":sql
    };
    console.log(parametros);
     return this.http.post(this.api+"indicadores/consulta.php", parametros, options).map(
      (response) => {
         
        
        return response.json();
        
      }
    ).catch(this.handleError);
  }

  private handleError (error: Response | any) {
    // In a real world app, you might use a remote logging infrastructure
    let errMsg: string;
    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.error || JSON.stringify(body);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    console.error(errMsg);
    return Observable.throw(errMsg);
  }

}



// WEBPACK FOOTER //
// ./src/providers/indicadores/indicadores.ts